import styles from './skeletons.module.scss'

export default function TodoListSkeleton() {
  return (
    <div className={styles.todoListSkeleton}>
      <div className={styles.header}>待办事项清单</div>
      <div className={styles.contentSkeleton}>
        <div className={styles.shortTextSkeleton}></div>
        {[1, 2, 3, 4, 5].map((item) => (
          <div key={item}>
            <div className={styles.shortTextSkeleton}></div>
            <div className={styles.longTextSkeleton}></div>
            <div className={styles.longTextSkeleton}></div>
            <div className={styles.middleTextSkeleton}></div>
          </div>
        ))}
      </div>
    </div>
  )
}
import styles from './skeletons.module.scss'

export default function TodoListSkeleton() {
  return (
    <div className={styles.todoListSkeleton}>
      <div className={styles.header}>待办事项清单</div>
      <div className={styles.contentSkeleton}>
        <div className={styles.shortTextSkeleton}></div>
        {[1, 2, 3, 4, 5].map((item) => (
          <div key={item}>
            <div className={styles.shortTextSkeleton}></div>
            <div className={styles.longTextSkeleton}></div>
            <div className={styles.longTextSkeleton}></div>
            <div className={styles.middleTextSkeleton}></div>
          </div>
        ))}
      </div>
    </div>
  )
}
